import ColumnLayout from '@cloudscape-design/components/column-layout';
import Container from '@cloudscape-design/components/container';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { MarketingContainer, SectionHeader } from '@vextura/shell';
import type { ReactNode } from 'react';
import { PAIN_POINTS } from '../content.js';

/**
 * PainPoints — three cards echoing what the reader told their boss last
 * week. Kept to three (not six) so nobody skims past. Each card is one
 * problem, no solution — the solution is BeforeAfter and Proof below.
 */
export function Pain(): ReactNode {
  return (
    <MarketingContainer paddingY="default">
      <SpaceBetween size="xl">
        <SectionHeader
          eyebrow="The problem"
          headline={
            <>
              You want to move fast.
              <br />
              You cannot use the cloud.
            </>
          }
          subhead="Three things every regulated engineering team hits within its first year of scale."
        />
        <ColumnLayout columns={3} variant="text-grid">
          {PAIN_POINTS.map((p) => (
            <Container key={p.title}>
              <SpaceBetween size="xs">
                <div style={{ fontSize: 18, fontWeight: 600 }}>{p.title}</div>
                <div style={{ color: '#64748b', lineHeight: 1.6 }}>{p.body}</div>
              </SpaceBetween>
            </Container>
          ))}
        </ColumnLayout>
      </SpaceBetween>
    </MarketingContainer>
  );
}
